import React from 'react';
import { StarIcon } from 'lucide-react';
const facts = [{
  value: '2,500+',
  label: 'Educators across USA, UK, Canada & Australia'
}, {
  value: '6 + 5',
  label: 'Volumes and bonuses included'
}, {
  value: '4.9/5',
  label: 'Community rating'
}, {
  value: 'Every week',
  label: 'Primary through advanced'
}];
export function SocialProofBar() {
  return <section aria-label="Social proof" className="border-y border-paper-300 bg-paper-200" data-id="element-234" data-mp="32jcz2mat9cfy">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-y-7 px-5 py-8 sm:px-6 sm:py-10 lg:grid-cols-4 lg:gap-x-8" data-id="element-235" data-mp="2xji9cm2ruswh">
        {facts.map((fact, index) => <div key={fact.value} className={`px-1 lg:px-6 ${index > 0 ? 'lg:border-l lg:border-paper-300' : ''}`} data-id="element-236" data-mp="2tkj5l4ss126m" data-mpi={index}>
            <p className="flex items-center gap-2 font-display text-2xl font-semibold leading-none text-ink sm:text-3xl" data-id="element-237" data-mp="1i3jcw82iolc2">
              {fact.value}
              {fact.value === '4.9/5' && <StarIcon className="h-4 w-4 fill-brass text-brass" aria-hidden="true" data-id="element-238" data-mp="18o2tyw4fvjt9" />}
            </p>
            <p className="mt-3 max-w-[15rem] text-xs leading-relaxed text-ink-muted" data-id="element-239" data-mp="1dm4c9eu1jf3o">{fact.label}</p>
          </div>)}
      </div>
    </section>;
}